import { html } from "../../base/_utils";

export default function staffCard(member, path) {
    return html`
        <div class="staff-card member-container mx-auto">
            <div class="project-info-container mx-auto">
                <img class="staff-img img-fluid" src="${path}${member.image}" alt="${member.name} headshot" />
            </div>
            <h4 class="staff-name mt-2 mb-1">${member.name}</h4>
            <span class="d-block mb-1">
                <strong class="staff-title text-primary">${member.title}</strong>
            </span>
            <div class="clearfix"></div>
        </div>
    `;
}
